// -------------------- Material Ui Table Components --------------
export {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination} from '@material-ui/core';
// -------------------- Material Ui Table Components --------------


// -------------------------------  ACTIONS -------------------------------------
export {createIntegrationData, getIntegrationData, submitIntegrationsForm} from '@/actions/pages/admins/dashboard/clients/integration';
export { SidebarAction } from "@/actions/components/sidebar";
export { sendToCurrentOnboardingSteps } from "@/actions/pages/admins/dashboard/clients/common";
// -------------------------------  ACTIONS -------------------------------------


//* This file contains the export files statement which will be export again in the pages
export { API, axios, clearSWRCache, DataFromUrl, Datetime, Field, Form, Formik, FieldArray, goToNextPage, handleOtherResponseCode, Image, imageSize,
         Link, motion, NextServerCookies, PAGE_ANIMATION_OPTIONS, REDIRECT, Sidebar, SUCCESS_REPONSE_CODE, toastr, useEffect, useRouter,
         useState, useTranslation, UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, useSWR, Yup, useQueryClient, ClientDashboard,
         ErrorPages, CustomToastrAction} from '@/imports-files/common/common';
// ----------------------------- COMMON ---------------------------------------


// ----------------------------- CONSTANT ---------------------------------------
export {INITIAL_VALUES, VALIDATION_SCHEMA} from '@/constants/pages/admins/dashboard/clients/integration';
export { CLIENT_ONBOARDING_STEPS } from "@/constants/common/onboarding-steps";
export { ADMIN_SIDEBAR_OPTIONS } from "@/constants/components/sidebar";
// ----------------------------- CONSTANT ---------------------------------------

// ----------------------------- ICONS ---------------------------------------
export { default as ArrowLeft} from 'public/icons/arrowleft.svg';
export { default as Filter } from 'public/icons/filter.svg';
// ----------------------------- ICONS ---------------------------------------

// -----------------------------  CUSTOM COMPONENTS -----------------------------
export {default as Button} from '@/components/button';
export {default as Congrats} from '@/components/congrats';
export { Checkbox } from "@material-ui/core";
export {default as TextField} from "@material-ui/core/TextField";
export { default as NumberFormat } from 'react-number-format';

// -----------------------------  CUSTOM COMPONENTS -----------------------------


// ----------------------------- SERVICES ---------------------------------------
export {SendRequest} from '@/services/common/send-request';
export {ClientIntegration} from '@/services/pages/admins/dashboard/clients/integration';
// ----------------------------- SERVICES ---------------------------------------


// ---------------------------- Stylesheet -------------------------------------
export {default as PageStyle} from '@/styles/pages/admins/dashboard/clients/new/_index.module.scss';
export {default as Styles} from '@/styles/pages/admins/dashboard/clients/integration/_index.module.scss';
export {default as ButtonStyle} from '@/styles/components/button/_index.module.scss';
export {default as PopupClasses} from '@/styles/components/congrats/_index.module.scss';
// ----------------------------- Stylesheet ------------------------------------
